import React, { useEffect } from "react";
import { connect } from "react-redux";
import { notification } from "../../../services";
import history from "../../../history";
import { selectLoadedUser } from "../auth.ducks";
import { UserI } from "../../../typings/interfaces";

export interface UserRoleProps {
  dispatch: Function;
  history: History;
  location: Location;
  match: { path: string; url: string; isExact: boolean; params: {} };
  staticContext: undefined;
  user: UserI | null;
}

export default (Com: Function, acceptableRoles: string[], navLink: string) => {
  const UserRoleComponent = (props: UserRoleProps) => {
    useEffect(() => {
      if (unacceptableUser(props)) {
        history.replace(navLink);
        notification.showError("Nemate dozvolu za pristup administratorskim značajkama");
      }
    }, []);

    const unacceptableUser = (props: UserRoleProps) => {
      const { user } = props;

      return !acceptableRoles.includes(user.role);
    };

    return unacceptableUser(props) ? null : <Com {...props} />;
  };

  return connect(
    state => ({
      user: selectLoadedUser(state)
    }),
    null
  )(UserRoleComponent);
};



// WEBPACK FOOTER //
// ./src/routes/Auth/HOCs/checkUserRole.tsx